
import React, {Component} from 'react';
import {Box} from 'reactjs-admin-lte'
import {Row,Col,FormGroup,Form,ControlLabel,Button,ButtonToolbar,Tabs,Tab,DropdownButton,MenuItem} from 'react-bootstrap'
import Select from 'react-select'
import {Checkbox} from 'react-icheck'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from '../../stores/WorkdocStore'
import AutopartStore from '../../stores/AutopartStore'
import ExportExcelButton from './ExportExcelButton';
import StockSearchPage from './StockSearchPage'
import StockEditProductModal from './StockEditProductModal';
import NormalCar_img from '../../asset/img/normalcar2.png';
import StockStore from '../../stores/StockStore';
import StockNewInOutModal from './StockNewInOutModal';
import StockProductTransactionModal from './StockProductTransactionModal';
import Moment from 'moment';
import './Stock.css'

class CarBrandValue extends Component {
  render () {
    return (
			<div className="Select-value" >
				<span className="Select-value-label">
          <span><img src={'https://demo2.bigfix.co/korat/img/car_brand/'+this.props.value.label+'-32x32.png'}/> </span>   
					{this.props.children}
				</span>
			</div>
		);
	}
}



class StockSearchPartSeriesPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {spotSel:-1,partGroupSel:"",loadingSpot:false,loadingList:false,btnDisplay:'none',
      checked:[],ck:[],rowCheck:[],dataInOut:[],countPartSelect:"",showStockNewInOut:false,record_type:"",defaultQu:[],defaultCost:[],
      brand:[],model:[],series:[],showResult:false,carBrandSel:null,carModelSel:null,carSeriesSel:null,catId:-1,
      partGroupList:[],partItemList:[],showStockPopup:false,dataSet:[],car_brand:'',car_model:'',car_series:'',localdata:[],
      showStockProductTransactionPopup:false,transaction_record:[],productImages:[]
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){      
        this.loadData()
    }
  }

  loadData(){
    this.loadBrandOptions()
  }

  loadBrandOptions(){
    let that = this
    WorkdocStore.loadCarCategory(0,function(result){
      let options = result.data.map((item,index)=>{
          return { value: item.cat_id, label: item.name }
        })
      that.setState({brand:options})
    })
  }

  onCarNumberClick(number){
    this.setState({spotSel:number,loadingSpot:true})
    let that = this
    AutopartStore.loadPartItem(number,function(result){
      //console.log('result',result)
      that.setState({partGroupList:result.data.list,loadingSpot:false,partGroupSel:"",partItemList:[],localdata:[]})
    },function(){
      that.setState({loadingSpot:false})
    })
  }

  onCarBrandChange(value){
    if (value!==null&&value!==undefined) {
      this.setState({carBrandSel:value,car_brand:value.label})
      let that = this
      if(value!==null && value!==undefined){
        WorkdocStore.loadCarCategory(value.value,function(result){
          let options = result.data.map((item,index)=>{
            return { value: item.cat_id, label: item.name }
          })
          that.setState({model:options})
        })
      }else{
        this.setState({model:[],series:[],modelSel:null,showResult:false})
      }
    } else {
      this.setState({carBrandSel:null,car_brand:'',model:[],series:[]})
    }
  }

  onCarModelChange(value){ 
    if (value!==null&&value!==undefined) {
      this.setState({carModelSel:value,car_model:value.label})
      let that = this
      if(value!==null && value!==undefined){
        WorkdocStore.loadCarCategory(value.value,function(result){
          let options = result.data.map((item,index)=>{
            return { value: item.cat_id, label: item.name }
          })
          that.setState({series:options})
        })
      }else{
        this.setState({model:[],series:[],seriesSel:null,showResult:false})
      }
    } else {
      this.setState({carModelSel:null,car_model:'',series:[]})
    }
  }

  onCarSeriesChange(value){
    if (value!==null&&value!==undefined) {
      this.setState({carSeriesSel:value,showResult:true,catId:value.value,car_series:value.label})
    } else {
      this.setState({carSeriesSel:null,showResult:false,catId:-1,car_series:''})
    }
  }

  handleSelect(){


  }

  onTextChange(){

  }

  onSearchClick(){

  }

  onSearchKeyPress(){

  }

  onInOutOpenClick(key, e) {

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const date = Moment().format('L LT').replace(Moment().format('YYYY'), yTh);

    if (key == "export") {
      var title = "เบิก/ขาย"
      if (this.props.tool == "tool" || this.props.tool == "officemate") {
        var titleTextInOut = "ผู้ขอเบิก"
      } else {
        var titleTextInOut = "ผู้ขอเบิก/ลค."
      }
    } else if (key == "import") {
      var title = "นำเข้า"
      var titleTextInOut = "ผู้นำเข้า"
    } else if (key == "request_purchase") {
      var title = "ขออนุมัติสั่งซื้อ"
      var titleTextInOut = "ผู้ขอสั่งซื้อ"
    }

    let { defaultQu,defaultCost } = this.state
    for (var i = 0; i < this.state.dataInOut.length; i++) {
      defaultQu[this.state.dataInOut[i].itemnum] = 1
      defaultCost[this.state.dataInOut[i].itemnum] = 0
    }

    this.setState({ defaultQu: defaultQu, record_type: key, showStockNewInOut: true, createDate: date, StockNewInOutTitle: title, titleTextInOut: titleTextInOut })
  }

  onProductDeleteClick(){

  }

  onPartClick(item, index, e){
    let {rowCheck,ck,dataInOut,car_brand,car_model,car_series,catId} = this.state
    // checked[item.itemnum] = !checked[item.itemnum]
    // this.setState({checked:checked})
    // this.refs['part-search-name'].onPartSeriesClick(item,index,e)

    if (!this.state.ck[item.itemnum]) {

      rowCheck.push(item.itemnum)
      dataInOut.push(item)
      this.setState({ rowCheck: rowCheck, dataInOut:dataInOut })

      this.state.ck[item.itemnum] = true
      this.setState({ ck: this.state.ck })

      let nItem = {}
      nItem['itemnum'] = item.itemnum
      nItem['detail'] = item.description
      nItem['productcode'] = item.productcode
      nItem['quantity'] = item.quantity
      this.refs.excelRef.getWrappedInstance().addItem(nItem)

    } else {

      var key = rowCheck.indexOf(item.itemnum);
      rowCheck.splice(key, 1)
      dataInOut.splice(key, 1)
      this.setState({ rowCheck: rowCheck, dataInOut:dataInOut })
      this.state.ck[item.itemnum] = false

      let rItem = {}
      rItem['itemnum'] = item.itemnum
      rItem['detail'] = item.description
      rItem['productcode'] = item.productcode
      rItem['quantity'] = item.quantity
      this.refs.excelRef.getWrappedInstance().removeItem(rItem)
    }

    if (rowCheck.length > 0) {
      this.setState({ btnDisplay: "inline" })
    } else {
      this.setState({ btnDisplay: "none" })
    }

    this.setState({ countPartSelect: rowCheck.length })
  }

  onPartGroupChange(event){
    let {spotSel,carSeriesSel,loadingList,checked} =  this.state
    let partGroupSel = event.target.value
    //Do nothing
    if(partGroupSel==="-1"){
      return 
    }
    this.setState({partGroupSel: partGroupSel,loadingList:true});

    

    let that = this
    let localdata = []
    //console.log('carSeriesSel',spotSel,partGroupSel,carSeriesSel)
    AutopartStore.loadStockPartList(spotSel,partGroupSel,carSeriesSel.value,"SEDAN",function(result){
      let data = result.data.list.map((item,index)=>{
        if(checked[item.part_id]===undefined)
          checked[item.part_id] = false

        localdata.push({isShowInfo:false})
        return item
      })
      that.setState({partItemList:data,loadingList:false,checked:checked,localdata:localdata})
      that.loadPartSeriesDetailClick()
    })
  }

  loadPartSeriesDetailClick() {
    let {catId,partItemList,car_brand,car_model,car_series} = this.state
    let that = this
    let car_info = car_brand+'/'+car_model+'/'+car_series
    partItemList.forEach(function(item,index) {
      let partType = 'original'
      StockStore.loadPartTypeInfo(item.itemnum,catId,function(result) {    
        if (item.partType!==undefined)
          partType = item.partType

        if (result.data.length>0) {
          partItemList[index] = Object.assign(item,{productcode:'',barcode:'',car_cat_id:catId,partType:partType,carInfo:{series:{value:catId},title:car_info},car_detail:car_info,old_info:result.data[0].old_info,original_info:result.data[0].original_info,similar_info:result.data[0].similar_info})
        } else {
          partItemList[index] = Object.assign(item,{productcode:'',barcode:'',car_cat_id:catId,partType:partType,carInfo:{series:{value:catId},title:car_info},car_detail:car_info,old_info:{},original_info:{},similar_info:{}})
        }
        that.setState({partItemList:partItemList})
      })
    })  
  }

  onNewItemClick(){
    let {showStockPopup} = this.state
    this.setState({showStockPopup:true})
  }

  onPartItemSelect(item){
    let {carBrandSel,carModelSel,carSeriesSel,checked} = this.state
    let title = carBrandSel.label+"/"+carModelSel.label+"/"+carSeriesSel.label
    item.carInfo = {title:title,brand:carBrandSel,model:carBrandSel,series:carSeriesSel}
    item.partType = 'original'

    checked[item.itemnum] = !checked[item.itemnum]
    
    this.setState({checked:checked})

    return item
  }

  renderBrandOption(option){
    return (
      <span><img src={'https://demo2.bigfix.co/korat/img/car_brand/'+option.label+'-32x32.png'}/> {option.label}</span>     
    )
  }

  

  renderSearch(){
    let {carTypeSel,carBrandSel,brand,carModelSel,model,carSeriesSel,series} = this.state
    return (
      <Row>
        <Col md={4}>
          <FormGroup >
              <ControlLabel>ยี่ห้อรถ</ControlLabel>
              <div>
              <Select   
              className='select-plus'         
              placeholder={'เลือกยี่ห้อรถ'}
              value={carBrandSel}
              valueComponent={CarBrandValue}
              onChange={this.onCarBrandChange.bind(this)}
              options={brand}
              optionRenderer={this.renderBrandOption.bind(this)}
              />  
                
              </div>
            </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup >
            <ControlLabel>โฉม</ControlLabel>
            <div>
            <Select   
            className='select-plus'         
            placeholder={'เลือกโฉม'}
            value={carModelSel}
            onChange={this.onCarModelChange.bind(this)}
            options={model}                   
            />  
               
            </div>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup >
              <ControlLabel>โฉมรถยนต์(แบบ) </ControlLabel>
              <div>
              <Select   
              className='select-plus'         
              placeholder={'เลือกแบบ'}
              value={carSeriesSel}
              onChange={this.onCarSeriesChange.bind(this)}
              options={series}              
              />  
                
              </div>
            </FormGroup>
        </Col>
      </Row>
    )
  }

  renderSearchName(){
    const title = <div><FontAwesome name='file-text-o' className="color-orange" /> สร้างใบสั่งซื้อสินค้า</div>
    const title2 = <div><FontAwesome name='arrow-down' className="color-blue" /> สร้างรายการเบิกคลัง/ขาย</div>
    const title3 = <div><FontAwesome name='arrow-up' className="color-green" /> สร้างรายการนำเข้าคลัง</div>
    const title4 = <div><FontAwesome name='trash' className="color-red" /> ลบสินค้า</div>
    const title5 = <div><FontAwesome name='shopping-cart' className="color-orange" /> สร้างรายการขออนุมัติสั่งซื้อ</div>
    
    let {btnDisplay} = this.state
    return (
      <Form inline>
        <ExportExcelButton ref='excelRef' />
        {' '}
        <DropdownButton bsStyle="primary" title="จัดการรายการ" key="" id="" style={{ display: btnDisplay }}>
          <MenuItem eventKey="1" style={{ display: 'none' }}>{title}</MenuItem>
          <MenuItem eventKey="2" onClick={this.onInOutOpenClick.bind(this, 'export')}>{title2}</MenuItem>
          <MenuItem eventKey="3" onClick={this.onInOutOpenClick.bind(this, 'import')}>{title3}</MenuItem>
          <MenuItem divider />
          <MenuItem eventKey="5" onClick={this.onInOutOpenClick.bind(this, 'request_purchase')}>{title5}</MenuItem>
          <MenuItem divider />
          <MenuItem eventKey="4" onClick={this.onProductDeleteClick.bind(this)}>{title4}</MenuItem>
        </DropdownButton>
      </Form>
    )
  }

  renderRowData(){
    let {partItemList,loadingList,checked,ck,localdata,car_brand,car_model,car_series} = this.state
    if(loadingList){
      return (
        <tr><td colSpan={7}><FontAwesome name='refresh'/>กำลังดึงข้อมูล...</td></tr>
      )
    }
    if(partItemList.length===0){
      return (
        <tr><td colSpan={7}><FontAwesome name="frown-o"/>ไม่พบข้อมูล</td></tr>
      )
    }
    // return partItemList.map((item,index)=>(
    //   <tr key={index}>
    //     <td className="text-center">
    //             <Checkbox
    //               onChange={this.onPartClick.bind(this, item, index)}
    //               checked={checked[item.part_id]}
    //               checkboxClass="icheckbox_square-blue"
    //               increaseArea="20%"
    //               label=""
    //             />              
    //     </td>
    //     <td>{item.description}</td>
    //     <td className="text-center">{item.original_quantity}</td>
    //     <td className="text-center">{item.similar_quantity}</td>
    //     <td className="text-center">{item.old_quantity}</td>
    //     <td className="text-center">{item.unit}</td>
    //     <td className="text-center">{item.location}</td>
    //     <td className="text-center">{item.remark}</td>
    //   </tr>
    // ))
    return(
            partItemList.map((item, index) =>
              [<tr key={index}>
                <td className="text-center">
                  <Checkbox
                    onChange={this.onPartClick.bind(this, item, index)}
                    checked={ck[item.itemnum]}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=""
                  />
                </td>                
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                  {item.description}
                  <br/>
                  {item.thumbnail_url!=''?<img src={item.thumbnail_url} style={{marginTop:'10px'}} />:''}
                </td>
                {/*<td>{car_detail}</td>*/}
                <td className='text-center'><Button bsSize='sm' onClick={this.onPartSeriesDetailClick.bind(this,item,index)}><FontAwesome name='info'/>{' '}{localdata[index].isShowInfo?'ซ่อนข้อมูล':'ดูข้อมูล'}</Button></td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.original_quantity}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.similar_quantity}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.old_quantity}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.unit}</td>
                {/*<td className="text-center">{item.cat_name}</td>*/}
              </tr>,
              this.renderPartInfo(item,index)              
              ]
            )
    )
  }

  onPartSeriesDetailClick(item,index) {
    let that = this
    let {partItemList,localdata,catId} = this.state
    
    if(partItemList.original_info===undefined){
      StockStore.loadPartTypeInfo(item.itemnum,catId,function(result) {      
        partItemList[index] = Object.assign(item,result.data[0])        
        that.setState({partItemList:partItemList})
      })      
    }
    localdata[index].isShowInfo = !localdata[index].isShowInfo
    this.setState({localdata:localdata})
  }


  renderNumber(value,type){
    if(type!==undefined && type==='number'){
      return (<td className='text-right'>{value!==undefined?(value*1).toLocaleString(undefined, {minimumFractionDigits: 0}):''}</td>)
    }else{
      return (<td>{value}</td>)
    }
  }

  renderPartInfo(item,index) {
    let {localdata} = this.state
    if(item.original_info!==undefined && localdata[index].isShowInfo){
      let rows = [{title:'ต้นทุนต่อหน่วย',key:'cost_per_unit',type:'number'},{title:'ราคาขายต่อหน่วย',key:'price_per_unit',type:'number'},
      {title:'รหัสสินค้า',key:'productcode'},{title:'บาร์โค๊ด',key:'barcode'},
      {title:'ชั้นวาง',key:'location'},{title:'หมายเหตุ',key:'remark'},]
      return rows.map((citem,cindex)=>(
        <tr key={(10000*index)+cindex}>              
              <td className='text-right' colSpan={3}>{citem.title}</td>
              {this.renderNumber(item.original_info[citem.key],citem.type)}
              {this.renderNumber(item.similar_info[citem.key],citem.type)}
              {this.renderNumber(item.old_info[citem.key],citem.type)}
          </tr>
      ))    
    }else if (localdata[index].isShowInfo) {
      let rows = [{title:'ต้นทุนต่อหน่วย',key:'cost_per_unit'},{title:'ราคาขายต่อหน่วย',key:'price_per_unit'},
      {title:'รหัสสินค้า',key:'productcode'},{title:'บาร์โค๊ด',key:'barcode'},
      {title:'ชั้นวาง',key:'location'},{title:'หมายเหตุ',key:'remark'},]
      return rows.map((citem,cindex)=>(
        <tr key={(10000*index)+cindex}>              
              <td className='text-right' colSpan={3}>{citem.title}</td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
      ))
    } else {
      return('')
    }
  }

  renderSportPartResult(){
    let {loadingSpot,partGroupList,partGroupSel} = this.state
    if(loadingSpot){
      return (
        <span>กำลังดึงข้อมูล...</span>
      )
    }
    if(partGroupList.length===0){
      return (
        <span>โปรดคลิ๊กเลือกวงกลมบนรูปรถยนต์</span>
      )
    }
    return (
      <div style={{minHeight:'512px'}}>
        <Row>
          <div style={{float:"left",width:"400px",margin:"5px"}}> 
            <select name="sel_part_group" className="form-control select2" 
              value={partGroupSel} 
              onChange={this.onPartGroupChange.bind(this)}>  
              <option value="-1">เลือกกลุ่มอะไหล่</option>        
              {
                partGroupList.map((item,index)=>(
                  <optgroup key={index} label={item.description+ " - " + item.description_en}>
                    {
                      item.sublist.map((iitem,iindex)=>(
                        <option key={iindex} value={iitem.group_id}>{iitem.description + " - " + iitem.description_en}</option>
                      ))
                    }
                  </optgroup>
                ))
              }                                                    
            </select>
          </div>
          <div style={{float:"left",margin:"5px"}}>
            {this.renderSearchName()}
          </div>  
        </Row>
        <Row>
          <Col md={12} style={{paddingRight:'40px'}}>
          <div className='display-overflow container-fixed' style={{display:(partGroupSel==="")?"none":"block",marginLeft:'-10px'}}>
            <table className="table table-responsive table-hover table-bordered-solid table-fixed">
              <thead>
                  <tr>
                    <th rowSpan={2} style={{width:'50px'}}></th>                    
                    <th rowSpan={2} className="col-md-4">ชื่ออะไหล่</th>
                    <th rowSpan={2} className="text-center" style={{width:'100px',display:'none'}}>รุ่นรถ</th>
                    <th rowSpan={2} style={{width:'80px'}}>ข้อมูล</th>                    
                    <th colSpan={3} className="text-center">จำนวน </th>
                    <th rowSpan={2} style={{width:'120px'}} className="text-center">หน่วยนับ</th>
                    <th rowSpan={2} className="text-center" style={{display:'none'}}>ประเภท</th>
                  </tr>
                  <tr>
                    <th style={{width:'100px'}} className="text-center">(แท้)</th>
                    <th style={{width:'100px'}} className="text-center">(เทียบ)</th>
                    <th style={{width:'100px'}} className="text-center">(เก่า/พิเศษ)</th>                  
                  </tr>
              </thead>
              <tbody>
                {this.renderRowData()}
              </tbody>
            </table>                       
          </div>
          <div style={{marginLeft:'-10px'}}>
              <ButtonToolbar>
                <Button className='bg-olive' onClick={this.onNewItemClick.bind(this)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการที่ไม่ได้อยู่ในตาราง</Button>                
              </ButtonToolbar>       
            </div>
          </Col>
        </Row>
      </div>      
    )
  }

  renderSearchByPosition(){
    let {spotSel} = this.state
    let spotCfg = [
      {left:50,top:0,spotNo:1},
      {left:20,top:90,spotNo:3},
      {left:20,top:190,spotNo:5},
      {left:20,top:270,spotNo:7},
      {left:20,top:360,spotNo:9},
      {left:60,top:460,spotNo:11},
      {left:180,top:0,spotNo:2},
      {left:210,top:90,spotNo:4},
      {left:210,top:190,spotNo:6},
      {left:210,top:270,spotNo:8},
      {left:210,top:360,spotNo:10},
      {left:180,top:460,spotNo:12},
      {left:115,top:220,spotNo:13},
    ]
    return (
      <Row>
        <table>
          <tbody>
            <tr>
                <td>
                    <div id="container" style={{position: "relative"}}>
                        <img src={NormalCar_img} id="img1" />
                        {
                          spotCfg.map((item,index)=>(
                            <div key={index} className={"damage-spot-circle "+(spotSel===item.spotNo?"bg-spot-select":"")} onClick={this.onCarNumberClick.bind(this,item.spotNo)} style={{position: "absolute",left:item.left+"px",top:item.top+"px"}}>{item.spotNo}</div>        
                          ))
                        }
                    </div>
                </td>
                <td style={{width: "100%"}}>

                    <div style={{minHeight:"511px"}} className="tab-pane active" id="tab_spot_part">
                      {this.renderSportPartResult()}                      
                    </div>

                </td>
            </tr>
          </tbody>
        </table>
      </Row> 
    )
  }

  renderResult(){
    let {showResult,catId,car_brand,car_model,car_series} = this.state
    let car_detail = car_brand+'/'+car_model+'/'+car_series
    return (
      <div style={{display:(showResult)?'block':'none'}}>
        <Tabs 
        defaultActiveKey="partcat" 
        animation={false} 
        id="car-part"
        onSelect={this.handleSelect.bind(this)}
      >    
        
            <Tab 
                eventKey={'partname'}
                title={<div><FontAwesome name='list-ol'/> ค้นหาด้วยชื่อ</div>}
              >       
                <br/>   
                <StockSearchPage                 
                ref={'part-search-name'}
                show={this.props.show && showResult}
                searchType={'brand'} 
                title={'อะไหล่(ตามรุ่นรถ)'}
                showCat={false} 
                catId={catId} 
                onItemSelect={this.onPartItemSelect.bind(this)}
                carDetail={car_detail}
                tool={'part'}/>
            </Tab>
            <Tab 
                eventKey={'partcat'}
                title={<div><FontAwesome name='puzzle-piece'/> ค้นหาตามประเภท</div>}
              >         
              <br/>    
                
                {this.renderSearchByPosition()}                                                 
            </Tab>
      </Tabs>
    </div>
    )
  }

  onTextStockEditProductChange(e) {

    let dataSet = this.state.dataSet
    dataSet[e.key] = e.value
    this.setState({ dataSet: dataSet, formValid: "", validState: "" })

  }

  onInOutCloseClick() {
    this.setState({ showStockNewInOut: false })
  }

  onInOutCancelClick() { 
    this.state.ck.map((item, index) => {
      if (item == true) {
        this.state.ck[index] = true // false
      }
    })
    this.setState({ showStockNewInOut: false, btnDisplay: "none", dataInOut: [], rowCheck: [], ck: this.state.ck })
  }

  onInOutDeleteClick(e) {
    let { rowCheck } = this.state
    let data = this.state.dataInOut
    var key = ""

    for (var i = 0; i < this.state.dataInOut.length; i++) {
      if (e == this.state.dataInOut[i].itemnum) {
        key = i
      }
    }

    data.splice(key, 1)
    this.state.ck[e] = false

    var keyRowCheck = rowCheck.indexOf(e)
    rowCheck.splice(keyRowCheck, 1)

    this.setState({ dataInOut: data, ck: this.state.ck, rowCheck: rowCheck, countPartSelect: rowCheck.length })
    if (rowCheck.length < 1) {
      this.setState({ btnDisplay: "none" })
    }
  }

  onInOutQuantityChange(e) {
    let { defaultQu } = this.state
    defaultQu[e.key] = e.value
    this.setState({ defaultQu: defaultQu })
  }

  onInOutCostChange(e) {
    let { defaultCost } = this.state
    defaultCost[e.key] = e.value
    this.setState({ defaultCost: defaultCost })
  }

  onPartTypeChange(index,value){
    let {dataInOut} = this.state
    dataInOut[index].partType = value.value
    this.setState({dataInOut:dataInOut})
  }

  loadStockTransactionRecord(item) {
    let that = this
    this.setState({transaction_record:[]})
    StockStore.loadStockTransactionRecord(this.props.tool, item.itemnum, function (result) {
      let data = result.data
      data.push({ cost_per_unit: item.cost_per_unit, added_date: item.added_date, record_type: 'init', request_by: item.added_by, quantity: 'ไม่มีข้อมูล' })
      that.setState({ transaction_record: data })
    },function(){
      
    })
  }

  onStockProductTransactionOpenClick(item, e) {
    let dataSet = {}
    dataSet = JSON.parse(JSON.stringify(item))
    dataSet['last_serial_id'] = ""
    dataSet['part_type'] = ""

    if(this.props.tool==='part' && this.props.searchType==='brand')
      dataSet['car_cat_id'] = this.props.catId

    this.setState({
      showStockProductTransactionPopup: true,
      description: item.description,
      added_date: item.added_date,
      added_by: item.added_by,
      quantity: item.quantity,
      unit: item.unit,
      remark: item.remark,
      productcode: item.productcode,
      last_serial_id: item.last_serial_id,
      itemnum: item.itemnum,
      cat_id: item.cat_id,
      dataSet: dataSet
    })
    this.loadStockTransactionRecord(item)
  }

  onStockProductTransactionCloseClick() {
    this.setState({ showStockProductTransactionPopup: false, itemnum: "", dataSet: {}, transaction_record: [] })
  }

  onStockEditProductOpenClick() {
    let {itemnum,cat_id} = this.state

    this.setState({
      showStockPopup: true,
      showStockProductTransactionPopup: false,
      transaction_record: [],
      productImages: [],      
    })

    if (itemnum > 0) {
      let that = this
      StockStore.loadImages(this.props.tool, itemnum, function (result) {
        that.setState({ productImages: result.data.files })
      })
    }
  }  

  onStockProductSerialManageClick(status) {
    let {showProductSerial} = this.state
    this.setState({showProductSerial:status})
  }



  onStockEditProductCloseClick() {
    this.setState({showStockPopup:false,itemnum: "",dataSet:[]})
  }

  onImageUpload() {
    let { itemnum } = this.state
    if (itemnum > 0) {
      let that = this
      StockStore.loadImages(this.props.tool, itemnum, function (result) {
        that.setState({ productImages: result.data.files })
      })
    }
  }

  onStockEditProductCategoryChange(e) {
    let dataSet = this.state.dataSet
    dataSet['cat_id'] = e
    this.setState({ cat_id: e, dataSet: dataSet })
  }

  onNewCategory() {
    this.loadCategory()
  }

  loadCategory() {
    let that = this
    StockStore.loadCategory(this.props.tool, function (result) {
      that.setState({ dataDd: result.data })
    })
  }

  onUpdateData(e) {
    let {partItemList} = this.state
    if (e.key==='edit') {
      partItemList.forEach(function(item,index) {
        if (item.itemnum===e.value.itemnum) {
          partItemList[index] = Object.assign(e.value,{cat_name:e.value.new_cat})
        }
      })
    } else if (e.key==='add') {
      partItemList.unshift({
        added_date:e.value.added_date,
        barcode:e.value.barcode,
        cat_id:e.value.cat_id,
        cat_name:e.value.new_cat,
        category:e.value.cat_id,
        cost_per_unit:e.value.cost_per_unit,
        price_per_unit:e.value.price_per_unit,
        itemnum:e.value.itemnum,
        location:e.value.location,
        remark:e.value.remark,
        unit:e.value.unit,
        quantity:e.value.quantity,
        productcode:e.value.productcode,
        description:e.value.description
      })
    }  
    this.setState({partItemList:partItemList})
  }

  onClearAfterSave() {
    this.setState({itemnum: "",dataSet:[]})
  }

  render(){
    return (
      <div>
        <Box>
          <Box.Header border={true}>
            <Box.Title>
              รายการอะไหล่ (โปรดระบุรุ่นรถ)
            </Box.Title>
          </Box.Header>
          <Box.Body>
            {this.renderSearch()}
            {this.renderResult()}
            <div>
              <StockNewInOutModal
                onShow={this.state.showStockNewInOut}
                onHide={this.onInOutCloseClick.bind(this)}
                onCancel={this.onInOutCancelClick.bind(this)}
                openInoutPrintAfterSubmit={this.props.openInoutPrintAfterSubmit}
                data={this.state.dataInOut}
                onDelete={this.onInOutDeleteClick.bind(this)}
                date={this.state.createDate}
                title={this.state.StockNewInOutTitle}
                titleTextInOut={this.state.titleTextInOut}
                stockType={'part'}
                recordType={this.state.record_type}
                allData={this.state.partItemList}
                quChange={this.onInOutQuantityChange.bind(this)}
                costChange={this.onInOutCostChange.bind(this)}
                defaultQu={this.state.defaultQu}
                defaultCost={this.state.defaultCost}
                onPartTypeChange={this.onPartTypeChange.bind(this)}
              >
              </StockNewInOutModal>
            </div>
            <div>
              <StockProductTransactionModal
                show={this.state.showStockProductTransactionPopup}
                onHide={this.onStockProductTransactionCloseClick.bind(this)}
                onEdit={this.onStockEditProductOpenClick.bind(this)}
                description={this.state.description}
                added_date={this.state.added_date}
                added_by={this.state.added_by}
                role={this.props.role}            
                quantity={this.state.quantity}
                unit={this.state.unit}
                itemnum={this.state.itemnum}            
                stockType={this.props.tool}
                transaction_record={this.state.transaction_record}
                onShowSerialNumber={this.onStockProductSerialManageClick.bind(this)}
              >
              </StockProductTransactionModal>
            </div>
            <div>
              <StockEditProductModal
                ref='editProduct'
                show={this.state.showStockPopup}
                onHide={this.onStockEditProductCloseClick.bind(this)}
                tool={this.props.tool}
                searchType={this.props.searchType}
                images={this.state.productImages}
                onCatChange={this.onStockEditProductCategoryChange.bind(this)}
                onTextChange={this.onTextStockEditProductChange.bind(this)}
                onImageUpload={this.onImageUpload.bind(this)}
                onNewCategory={this.onNewCategory.bind(this)}
                dataSet={this.state.dataSet}
                updateData={this.onUpdateData.bind(this)}
                clearAfterSave={this.onClearAfterSave.bind(this)}
              >
              </StockEditProductModal>
            </div>
          </Box.Body>
        </Box>
      </div>
    )
  }
}

StockSearchPartSeriesPage.defaultProps = {
  show :false
}

export default StockSearchPartSeriesPage;





// WEBPACK FOOTER //
// ./src/view/stock/StockSearchPartSeriesPage.js